module.exports = __webpack_public_path__ + "media/post-listing-block-4-image@2x.e13f5a17.webp";